import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "replacementCar"
const ReplacementCarIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 3v2h6V3l3 3-3 3V7H9v2L6 6l3-3Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.253 19.412H5.305v.6a.6.6 0 0 1-.601.602H3.502a.6.6 0 0 1-.6-.601v-3.605c0-.206.005-.41.016-.61a1.052 1.052 0 1 1 .355-2.07C3.779 12.093 4.788 11 6.206 11h4.206c.207 0 .405.023.594.068a5.034 5.034 0 0 0-.826 1.135l-.068-.001H6.506c-2.103 0-2.103 2.403-2.103 3.004h3.998c.115.522.426.97.852 1.264v2.942ZM5.004 18.21a.901.901 0 1 1 0-1.802.901.901 0 0 1 0 1.802Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.727 13.727C20.221 12.094 19.212 11 17.794 11h-4.206c-1.418 0-2.427 1.094-2.933 2.727a1.051 1.051 0 1 0-.355 2.071c-.011.2-.017.404-.017.61v3.605a.6.6 0 0 0 .601.6h1.202a.6.6 0 0 0 .6-.6v-.601h6.01v.6a.6.6 0 0 0 .6.602h1.202a.6.6 0 0 0 .6-.601v-3.605c0-.206-.005-.41-.016-.61a1.052 1.052 0 1 0-.355-2.07Zm-8.942 1.479c0-.6 0-3.004 2.103-3.004h3.606c2.103 0 2.103 2.403 2.103 3.004h-7.812Zm7.21 3.004a.901.901 0 1 1 0-1.802.901.901 0 0 1 0 1.802Zm-6.609 0a.901.901 0 1 1 0-1.802.901.901 0 0 1 0 1.802Z"
      />
    </svg>
  )
}
export default ReplacementCarIcon
